import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const clampedTextStyleId = 'wb-clamped-text-theme';

export const clampedTextBridgeStyles = {
  'w-clamped-text': {
    '--local-clamped-text-font-size': tokens.font.size.textMdBase,
    '--local-clamped-text-line-height': tokens.lineHeight.textMd,
    '--local-clamped-text-font-weight': tokens.font.weight.regular,
    '--local-clamped-text-color': tokens.color.text.primary,
    '--local-clamped-text-toggle-color': tokens.color.text.tertiary,
    // Quiet-field value inset (matches detail-page field rows).
    '--local-clamped-text-inset-y': '5px',
    '--local-clamped-text-inset-x': tokens.spacing.md,
    // Gap between the last line's text and the toggle, floated or inline.
    '--local-clamped-text-toggle-gap': tokens.spacing.sm,
  },
};
